<component-loading />

@if (breadcrumbService.breadcrumbs()) {
  <component-breadcrumb />
}

@for (message of notificationService.messages(); track message) {
  <div class="mt-2">
    <p-message [severity]="message.severity" [text]="message.content" [life]="message.life" closable></p-message>
  </div>
}

<router-outlet />

<p-scrolltop />
